// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nh+F-","loaderWrapper":"styles_loaderWrapper__9TrfY"};